import React, { useEffect, useState } from 'react';
import Theme from '../theme/theme';
import lemonadeGlobalThemeData from '../theme/global_data';
import ThemeContext, { defaultTheme } from './theme';
import { makeCancelTokenSource, handleApiError } from '../api_client/get';

const ThemeProvider = (props) => {
  const { apiClient, children } = props;
  const [theme, setTheme] = useState(defaultTheme);

  useEffect(() => {
    let unmounted = false;
    const cancelTokenSource = makeCancelTokenSource();
    apiClient.getTheme(cancelTokenSource)
      .then(({ data }) => {
        if (unmounted) return;
        if (data.success) {
          setTheme(new Theme(lemonadeGlobalThemeData(data.theme)));
        } else {
          console.log('Could not load the theme data.');
          throw new Error(data.message);
        }
      })
      .catch(error => {
        if (unmounted) return;
        handleApiError(error, console.log);
      });
    return () => {
      cancelTokenSource.cancel();
      unmounted = true;
    };
  }, [apiClient]);

  return (
    <ThemeContext.Provider value={theme}>
      {children}
    </ThemeContext.Provider>
  );
};

export default ThemeProvider;
